import { mailtoLink, whatsappLink } from '@isbd/shared';

/** Normalise un numéro local (CI) pour wa.me : 07… → 22507… */
export function normalizePhoneForWhatsapp(raw: string): string {
  const cleaned = raw.replace(/[^\d]/g, '');
  if (!cleaned) return '';
  if (cleaned.startsWith('225')) return cleaned;
  if (cleaned.startsWith('0')) return `225${cleaned.slice(1)}`;
  return cleaned;
}

export function contactWhatsappLink(phone: string, text: string): string {
  const n = normalizePhoneForWhatsapp(phone);
  return n ? whatsappLink(n, text) : '';
}

export function contactMailLink(email: string, subject: string, body: string): string {
  return email.trim() ? mailtoLink(email.trim(), subject, body) : '';
}

export function contactTelLink(phone: string): string {
  const p = phone.trim();
  return p ? `tel:${p}` : '';
}
